export default {
  errors: {
    internal: 'Ha ocurrido un error inesperado, por favor intente de nuevo.',
    business: 'La tarjeta ingresada ha sido declinada. Por favor intenta con otro método de pago.',
    threeDsTimeout: 'La autenticación con 3D Secure tardó demasiado. Por favor intenta de nuevo.',
    threeDsScriptLoad: 'No se pudo cargar la autenticación con 3D Secure. Por favor intenta de nuevo.',
    order: {
      emptyCustomerId: 'No se recibió el customerId en la creación de la orden',
    },
  },
  loading: {
    default: 'Autenticando pago\ncon 3D Secure 2',
  },
};
